import { render, staticRenderFns } from "./currentGames.vue?vue&type=template&id=0a7956aa&"
import script from "./currentGames.vue?vue&type=script&lang=js&"
export * from "./currentGames.vue?vue&type=script&lang=js&"
import style0 from "./currentGames.vue?vue&type=style&index=0&id=0a7956aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports